import { useRouter } from "next/router";
import React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { isUserLogin } from "store/loginReducer";

export const WithLogin = (Component) => {
  const WithLoginComponent = (props) => {
    const isLogin = useSelector(isUserLogin);
    const router = useRouter();

    useEffect(() => {
      if (!isLogin) router.replace("/");
    }, [isLogin]);

    return <Component {...props} />;
  };
  return WithLoginComponent;
};
